jQuery(document).ready(function($) {
    function equalizeBlogCardHeights() {
        var maxHeight = 0;
        $('.featured-blog-card').css('height', 'auto'); // Reset
        $('.featured-blog-card').each(function() {
            var thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) maxHeight = thisHeight;
        });
        $('.featured-blog-card').height(maxHeight);
    }

    equalizeBlogCardHeights();
    $(window).on('resize', equalizeBlogCardHeights);
});
